import SEO from "../components/SEO";
import { ComplianceSection } from "../components/CompanySections";
export default function Compliance() {
 return <div className="pt-6"><SEO title="Compliance — S H & SONS ®" description="Certifications, membership and audit status. Request compliance documents for your international sourcing review." /><ComplianceSection /></div>;
}

